<template>
    
    <div id="appointments" class="container m-auto pt-24 px-4" >

        <div>

            <p class="text-gray-500" >Upcoming</p>

            <h1 class="text-4xl font-medium" >Appointments</h1>

        </div>

        <calendar class="mt-10" @direction="direction = $event" />

        <div class="mt-10" >

            <div 
            
            class="w-full h-12 bg-gray-100 grid grid-cols-20 gap-6 border-gray-300 border-solid rounded-b-none"

            :class="{ 
                'border-b': stickyHeader,
                'rounded-cs-md': !stickyHeader
            }"

            v-sticky:80="setStickyHeader" 
            v-not-sticky:80="removeStickyHeader" 
            
            >

                <div class="h-full col-span-2" ></div>

                <p class="text-sm text-gray-600 h-full flex items-center col-span-2" >Clinic</p>

                <p class="text-sm text-gray-600 h-full flex items-center col-span-4" >Client</p>

                <p class="text-sm text-gray-600 h-full flex items-center col-span-3" >Animal</p>

                <p class="text-sm text-gray-600 h-full flex items-center col-span-2" >Species</p>

                <p class="text-sm text-gray-600 h-full flex items-center col-span-4" >Weight</p>

            </div>

            <transition name="error" mode="out-in" >

                <div 
                
                class="flex flex-col items-center space-y-4 p-20" 
                
                v-if="!appointmentsLoader && appointments.length === 0" 
                
                >

                    <p class="text-sm text-gray-500" >There are no {{ direction }} appointments.</p>

                </div>

                <div v-else-if="!appointmentsLoader || appointments.length > 0" class="border-t-2 border-solid border-white" >

                    <appointment 
                    
                    :key="item.id"
                    :appointment="item"
                    :selected="selectedAppointments.includes(item.id)"
                    
                    v-for="item in appointments"

                    @select="handleAppointment" 
                    
                    />

                </div>

                <div v-else class="flex flex-col items-center space-y-4 p-20" >

                    <img src="/images/loader.svg" alt="loader" >

                    <p class="text-sm text-gray-500" >Fetching appointments...</p>

                </div>

            </transition>

            <div 

            class="w-full h-20 bg-gray-100 flex items-center p-4 border-gray-300 border-solid rounded-t-none"

            :class="{
                'border-t': stickyFooter,
                'rounded-cs-md': !stickyFooter
            }"
            
            v-sticky:0.bottom="setStickyFooter" 
            v-not-sticky:0.bottom="removeStickyFooter"
            
            >

                <p class="text-sm flex-grow" >{{ appointments.length }} TOTAL</p>

                <p class="text-xs text-right text-gray-500 mr-4" >Select multiple appointments <br /> and sign them at once.</p>

                <button class="btn" @click.prevent="bulkSign" >Bulk Sign</button>

            </div>

        </div>

    </div>

</template>

<script>

    import { ref, reactive, computed, onMounted } from 'vue'
    import { useStore } from 'vuex'

    import { sticky } from '../assets/scripts/sticky'
    import { notSticky } from '../assets/scripts/sticky'

    import calendar from '../components/calendar'
    import appointment from '../components/appointment'

    export default {
    
        name: 'Appointments',

        components: { appointment, calendar },

        setup( props, context ) {

            const store = useStore()

            const appointments = computed(() => store.state.appointments.appointments )
            const appointmentsLoader = computed(() => store.state.appointments.appointmentsLoader )

            let selectedAppointments = ref([])

            const handleAppointment = (e) => {

                if ( selectedAppointments.value.includes(e) ) {

                    selectedAppointments.value = selectedAppointments.value.filter( a => a != e )

                }

                else selectedAppointments.value.push(e)

            }

            const bulkSign = () => {

                alert(JSON.stringify(selectedAppointments.value, null, 4))

            }

            const stickyHeader = ref(false)

            const setStickyHeader = () => { stickyHeader.value = true }
            const removeStickyHeader = () => { stickyHeader.value = false }

            const stickyFooter = ref(false)

            const setStickyFooter = () => { stickyFooter.value = true }
            const removeStickyFooter = () => { stickyFooter.value = false }

            const direction = ref("available")

            onMounted(() => {
                store.dispatch('getAppointments')
            })

            return {
                bulkSign,
                direction,
                appointments,
                stickyHeader,
                stickyFooter,
                setStickyHeader,
                setStickyFooter,
                handleAppointment,
                removeStickyHeader,
                removeStickyFooter,
                appointmentsLoader,
                selectedAppointments
            }

        },

        directives: { sticky, notSticky }

    }

</script>